namespace SP {
	export interface PackageLine {
		id: string;
		orderLineId: string;
		packageId: string;
		quantity: number;
		transferCompletedAt: string | undefined;
	}
}